import { Plural } from "@lingui/macro";
import { ApiEpBilling, IApiEpBillingProduct } from "@smp/api";
import { UiBox, UiGrid } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import { useState } from "react";
import { useQuery } from "react-query";

import { BlockTryPro } from "@/components/blocks/block_try_pro";
import { useEpBillingFeatureList } from "@/hooks/use_ep_billing_feature";
import { useContextApp } from "@/screens/app/context/app";

import { DialogPurchase } from "../../dialog_purchase";
import { UiProduct } from "../../shared/ui_product";

export const Watermark = ({
  onClose,
  onClickTryPro,
}: {
  onClose: () => void;
  onClickTryPro?: () => void;
}) => {
  const {
    state: { me },
  } = useContextApp();
  const { featureList } = useEpBillingFeatureList();
  const [product, setProduct] = useState<IApiEpBillingProduct | undefined>(
    undefined,
  );

  const featureVideo = featureList?.find(
    (feature) => feature.name === "watermark_slot",
  );

  const { data: productFeatureSubscriptions } = useQuery(
    [
      "ep.billing.product.feature_subscription",
      { query: { is_single_payment_allowed: true } },
    ],
    () =>
      ApiEpBilling.Product.FeatureSubscription.list({
        query: { is_single_payment_allowed: true },
      }),
  );

  const productFeatureSubscriptionsWatermarkSlot =
    productFeatureSubscriptions?.filter(
      (productFeatureSubscription) =>
        productFeatureSubscription.feature === featureVideo?.id,
    );

  const handleClose = () => {
    setProduct(undefined);
    onClose();
  };

  const handleProductChange = (product: IApiEpBillingProduct) => {
    setProduct(product);
  };

  if (!productFeatureSubscriptionsWatermarkSlot) {
    return null;
  }

  return (
    <>
      <UiBox>
        <UiGrid container spacing={2}>
          {productFeatureSubscriptionsWatermarkSlot
            .sort((a, b) => {
              if (a.period_days > b.period_days) return 1;
              if (a.period_days < b.period_days) return -1;
              return 0;
            })
            .map((productFeatureSubscriptionWatermarkSlot) => (
              <UiGrid
                item
                key={productFeatureSubscriptionWatermarkSlot.id}
                // TODO: this is so dirty
                xs={
                  productFeatureSubscriptionsWatermarkSlot.length === 1 ? 12 : 6
                }
                sm={
                  productFeatureSubscriptionsWatermarkSlot.length === 1 ? 12 : 4
                }
              >
                <UiProduct
                  fullWidth
                  name={
                    <Plural
                      zero={`slots`}
                      one={`slot`}
                      few={`slots`}
                      many={`slots`}
                      other={`slots`}
                      value={1}
                    />
                  }
                  onClick={handleProductChange}
                  product={productFeatureSubscriptionWatermarkSlot}
                  {...testAppendAttr("class", "buy_watermark_slot")}
                />
              </UiGrid>
            ))}
          {me.billing_policy_base === "classic" && (
            <UiGrid item xs={12}>
              <BlockTryPro
                additionalAction={() => {
                  onClose();
                  onClickTryPro && onClickTryPro();
                }}
              />
            </UiGrid>
          )}
        </UiGrid>
      </UiBox>
      {!!product && (
        <DialogPurchase
          onClose={handleClose}
          open={!!product}
          product={product}
        />
      )}
    </>
  );
};
